<div class="year-container">
    <app-events-booking-year [schoolYear]="schoolYear$ | async">
        <ng-content></ng-content>
    </app-events-booking-year>
</div>
